import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAllAppliedLeaves, handleWithdraw } from "../../api/leavesApi";
import "../../css/CustomTable.css";

const AppliedLeaveList = () => {
  const navigate = useNavigate();
  const [leaveList, setLeaveList] = useState([]);
  const employeeCode = sessionStorage.getItem("username");

  useEffect(() => {
    fetchLeaves();
  }, []);

  const fetchLeaves = async () => {
    try {
      const data = await getAllAppliedLeaves(employeeCode);
      setLeaveList(data || []);
    } catch (error) {
      console.error("Failed fetching leave details", error);
      setLeaveList([]);
    }
  };

  const withdrawLeave = async (leaveAppID) => {
    try {
          console.log("Withdraw request:", { leaveAppID, employeeCode, trUser: employeeCode });
      await handleWithdraw(leaveAppID,employeeCode);
      alert("Leave withdrawn successfully!");
      fetchLeaves(); // refresh list
    } catch (error) {
      alert("Failed to withdraw leave");
    }
  };

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="allowance-heading mb-0">Applied Leave List</h4>
        <button className="btn btn-secondary btn-sm" onClick={() => navigate(-1)}>
          ← Back
        </button>
      </div>

      <div className="allowance-table-container">
        <table className="allowance-table">
          <thead>
            <tr>
              <th>Sr. No.</th>
              <th>Leave Name</th>
              <th>Start Date(dd-mm-yyyy)</th>
              <th>End Date(dd-mm-yyyy)</th>
              <th>No. of Days</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {leaveList.length > 0 ? (
              leaveList.map((leave, index) => (
                <tr key={index}>
                  <td>{leave.leaveAppID}</td>
                  <td>{leave.leaveName}</td>
                  <td>{new Date(leave.startDate).toLocaleDateString()}</td>
                  <td>{new Date(leave.endDate).toLocaleDateString()}</td>
                  <td>{leave.noOfDays}</td>
                  <td>
                    <span
                      className={`badge ${
                        leave.status === "Approved"
                          ? "bg-success"
                          : leave.status === "Rejected"
                          ? "bg-danger"
                          : "bg-warning text-dark"
                      }`}
                    >
                      {leave.status}
                    </span>
                  </td>
                  <td>
                    {leave.status === "Pending" && (
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => withdrawLeave(leave.leaveAppID)}
                      >
                        Withdraw
                      </button>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center">
                  No leave applications found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AppliedLeaveList;




// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";

// import {getAllAppliedLeaves} from "../../api/leavesApi"
// import "../../css/CustomTable.css";

// const AppliedLeaveList = () => {
//   const navigate = useNavigate();
//   const [leaveList, setLeaveList] = useState([]);
//   const employeeCode = sessionStorage.getItem("username");
//   useEffect(() => {
//    fetchLeaves();
//   }, []);

//   const fetchLeaves = async () => {
//       try {
//         const data = await getAllAppliedLeaves(employeeCode);
//         setLeaveList(data || []);
//       } catch (error) {
//         console.error("Failed fetching leave details", error);
//         setLeaveList([]);
//       }
//     };
  
//   return (
//     <div className="container mt-4">
//       {/* <h5 className="mb-3">Applied Leave List</h5> */}
//       <div className="d-flex justify-content-between align-items-center mb-3">
//         <h4 className="allowance-heading mb-0">Applied Leave List</h4>
//         <button className="btn btn-secondary btn-sm" onClick={() => navigate(-1)}>
//           ← Back
//         </button>
//       </div>
//      <div className="allowance-table-container">
//       <table className="allowance-table">
//         <thead>
//           <tr>
//             <th>Sr. No.</th>
//             <th>Leave Name</th>
//             <th>Start Date(dd-mm-yyyy)</th>
//             <th>End Date(dd-mm-yyyy)</th>
//             <th>No. of Days</th>
//             <th>Status</th>
//           </tr>
//         </thead>
//         <tbody>
//           {leaveList.length > 0 ? (
//             leaveList.map((leave, index) => (
//               <tr key={index}>
//                 <td>{leave.leaveAppID}</td>
//                 <td>{leave.leaveName}</td>
//                 <td>{new Date(leave.startDate).toLocaleDateString()}</td>
//                 <td>{new Date(leave.endDate).toLocaleDateString()}</td>
//                 <td>{leave.noOfDays}</td>
//                 <td>
//                   <span
//                     className={`badge ${
//                       leave.status === "Approved"
//                         ? "bg-success"
//                         : leave.status === "Rejected"
//                         ? "bg-danger"
//                         : "bg-warning text-dark"
//                     }`}
//                   >
//                     {leave.status}
//                   </span>
//                 </td>
//               </tr>
//             ))
//           ) : (
//             <tr>
//               <td colSpan="6" className="text-center">
//                 No leave applications found.
//               </td>
//             </tr>
//           )}
//         </tbody>
//       </table>
//     </div>
//    </div> 
//   );
// }

// export default AppliedLeaveList;
